import { createContext, useState, useEffect } from "react";
import toast from "react-hot-toast";

export const CartContext = createContext();

export const CartContextProvider = ({ children }) => {
  const today = new Date();


  const contentEvents = [{
    datetimeEvents: [],
    title: 'Busca productos impresos en 3d',
    description: 'Puedes ver los productos disponibles que tenemos o consultarnos sobre impresiones personalizadas dentro de nuestra plataforma.\n\n ¡Encuentra lo que necesitas y consultanos!',
    color: null,
    href: "/products3d"
  },
  {
    name: "Dia de la madre",
    datetimeEvents: [{
      start: '2025-10-01',
      end: '2025-10-24'
    }],
    title: 'Sorprende a mamá con un regalo único y personalizado.',
    description: 'Descubre detalles hechos con amor: grabados láser elegantes y creaciones en 3D diseñadas especialmente para ella.\n\n🎁 Regalos que no encontrará en ninguna tienda… ¡porque están hechos solo para tu mamá!',
    color: "#c93384",
    href: "/event/Dia de la madre"
  }
  ]

  const event = contentEvents.find(event => {
    return event.datetimeEvents.some(range => {
      const startDate = new Date(range.start);
      const endDate = new Date(range.end);
      return today >= startDate && today <= endDate;
    });
  }) || contentEvents[0];

  const [cart, setCart] = useState(() => {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  });

  const [productsLaser, setProductsLaser] = useState([]);
  const [products3dprinter, setProducts3dprinter] = useState([]);
  const [productsMates, setProductsMates] = useState([]);
  const [productsBbq, setProductsBbq] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [discountList, setDiscountList] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(true);

  const maintenance = false;

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const laserRes = await fetch(process.env.REACT_APP_PRODUCTS_LASER,  {
        // const laserRes = await fetch("http://localhost:3000/productsLaser", {
          headers: {
            "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`, // o el token que tengas
          }
        });
        const laserData = await laserRes.json();
        setProductsLaser(laserData);

        const printerRes = await fetch(process.env.REACT_APP_PRODUCTS3D_PRINTER);
        // const printerRes = await fetch("http://localhost:3000/products3dprinter");
        const printerData = await printerRes.json();
        setProducts3dprinter(printerData);

        const matesRes = await fetch(process.env.REACT_APP_PRODUCTSMATES);
        // const matesRes = await fetch("http://localhost:3000/productsMates");
        const matesData = await matesRes.json();
        setProductsMates(matesData);
        setAllProducts([...laserData, ...printerData, ...matesData]);

         const bbqRes = await fetch(process.env.REACT_APP_PRODUCTSBBQ);
        // const bbqRes = await fetch("http://localhost:3000/productsBbq");
        const bbqData = await bbqRes.json();
        setProductsBbq(bbqData);
        setAllProducts([...laserData, ...printerData, ...matesData]);

         const discountRes = await fetch(process.env.REACT_APP_DISCOUNT);
        // const discountRes = await fetch("http://localhost:3000/cart");
        const discountData = await discountRes.json();
        setDiscountList(discountData);
      } catch (error) {
        toast.error("Error al crear preferencia");
      }
      finally {
        setLoadingProducts(false);
      }
    };

    fetchProducts();
  }, []);

  const addItem = (productToAdd) => {
    if (!isInCart(productToAdd.slug)) {
      setCart([...cart, productToAdd]);
    } else {
      const cartUpdated = cart.map(prod => {
        if (prod.slug === productToAdd.slug) {
          return {
            ...prod,
            price: productToAdd.price,
            quantity: productToAdd.quantity + prod.quantity,
            stock: productToAdd.stock
          };
        } else {
          return prod;
        }
      });
      setCart(cartUpdated);
    }
  };

  const changeQuantity = (item, quantity) => {
    const cartUpdated = cart.map(prod => {
      if (prod.slug === item.slug) {
        return {
          ...prod,
          quantity: quantity
        };
      } else {
        return prod;
      }
    });
    setCart(cartUpdated);
  };

  const isInCart = (slug) => {
    return cart.some(prod => prod.slug === slug);
  };

  const removeItem = (slug) => {
    const cartWithoutItem = cart.filter(prod => prod.slug !== slug);
    setCart(cartWithoutItem);
  };

  const clearCart = () => {
    setCart([]);
  };

  const getProductQuantity = (id) => {
    const product = cart.find(prod => prod.id === id);
    return product?.quantity;
  };

  return (
    <CartContext.Provider
      value={{
        event,
        cart,
        addItem,
        isInCart,
        removeItem,
        clearCart,
        getProductQuantity,
        changeQuantity,
        productsLaser,
        products3dprinter,
        productsMates,
        productsBbq,
        allProducts,
        loadingProducts,
        maintenance,  
        discountList
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;